<a href="javascript:void(0)" *ngIf="webApi.isLoggedIn() else loginDropdown" (click)="webApi.logout()" class="nav-item nav-link">SIGN OUT</a>
<ng-template #loginDropdown>

    <div class="dropdown login-drop">
        <a class="nav-item nav-link dropdown-toggle" href="#" id="loginLink" data-bs-auto-close="true"
            data-bs-toggle="dropdown" data-bs-offset="50,20" aria-expanded="false">
            LOGIN
        </a>

        <div class="dropdown-menu dropdown-menu-end login login-menu">
            <form class="py-2 p-3" [formGroup]="loginForm" (ngSubmit)="onSubmit($event,loginForm)">
                <h5>Welcome Back!</h5>
                <p>Login to CheerForge</p>
                <div class="mb-2">
                    <label for="" class="form-label">Username</label>
                    <input type="email" class="form-control" formControlName="email">
                    <div class="invalid-feedback d-block"
                        *ngIf="f['email'].errors?.['required'] && (f['email'].dirty || f['email'].touched)">
                        Please fill valid email.
                    </div>
                </div>
                <div class="mb-2">
                    <label for="passwordInput" class="form-label">Password</label>
                    <input type="password" class="form-control" formControlName="password" id="passwordInput">
                    <div class="invalid-feedback d-block"
                        *ngIf="f['password'].errors?.['required'] && (f['password'].dirty || f['password'].touched)">
                        Please fill password.
                    </div>
                    <div class="invalid-feedback d-block"
                        *ngIf="f['password'].errors?.['required'] && (f['password'].dirty || f['password'].touched)">
                        Your password must have minimum 8 characters.
                    </div>
                </div>
                <!-- <div class="mb-2">
                <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="dropdownCheck">
                    <label class="form-check-label" for="dropdownCheck">
                        Remember me
                    </label>
                </div>
            </div> -->
                <div class="d-flex justify-content-between align-items-center mt-4">
                    <!-- [disabled]="loginForm.invalid" -->
                    <a (click)="onSubmit($event,loginForm)"
                        class="btn btn-sm btn-gold">Login  <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></a>
                    <a routerLink="/forgot-password">Forgot Password</a>
                </div>
            </form>

        </div>
    </div>

</ng-template>